import PerfectScrollbar from 'perfect-scrollbar';

let scrollbar = null;
let tabletScrollbar = null;

$(function() {
    scrollbar = $('.js-scrollbar').map((i, item) => new PerfectScrollbar(item));
    tabletScrollbar = $('.js-tablet-scrollbar').map((i, item) => new PerfectScrollbar(item));

    if (!tabletScrollbar.length) return;

    if ($(document).width() < 768) {
        tabletScrollbar.each((i, item) => item.destroy());
    }

    $(window).resize(() => {
        if ($(document).width() < 768) {
            tabletScrollbar.each((i, item) => item.destroy());

            return;
        }
        tabletScrollbar.each((i, item) => item.update());
    });
});

export default {
    scrollbar: scrollbar,
    tabletScrollbar: tabletScrollbar,
};



// WEBPACK FOOTER //
// ./resources/assets/js/components/common/scrollbar.js